import RankOrderRowViewModel from "./RankOrderRowViewModel";

export default class RankOrderViewModel {
    total: number | null = null;
    arrivalMedian: number | null = null;
    departureMedian: number | null = null;
    totalMedian: number | null = null;
    arrivalMean: number | null = null;
    departureMean: number | null = null;
    totalMean: number | null = null;
    rows: RankOrderRowViewModel[] | null = null;
    count: number | null = null;
    abbreviation: string | null = null;
    unit: string | null = null;
    calculationValue: string | null = null;
    percentile85: string | null = null;
    percentile85Rank: number | null = null;
    totalPercentile85: number | null = null;
    percentile15: string | null = null;
    percentile15Rank: number | null = null;
    totalPercentile15: number | null = null;
    selectedRange: string | null = null;
    mainUse: string | null = null;
    subUse: string | null = null;
    vehicleType: number = 0;
}
